import DraggableItem from './DraggableItem';
import {
  type SelectableItemController,
  type SelectableItemType,
} from './SelectableItem';

class UndraggableItem<
  ItemType extends SelectableItemType = any,
  Controller extends SelectableItemController = any,
  DropType extends SelectableItemType = ItemType
> extends DraggableItem<ItemType, Controller, DropType> {
  canDrag(): boolean {
    return false;
  }
}

export default UndraggableItem;
